import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import { useState } from "react";

/**
 * A dialog's confirm button state, from the dialog's own attempt rather than
 * the mutation's `called`/`data`, which outlive the dialog: read from those, a
 * dialog reopened after a failure (or a success) would open showing it. Call
 * `reset()` when the dialog opens and `run(call)` for the write it confirms.
 */
export const useWsmFitmentAttempt = () => {
  const [state, setState] = useState<ConfirmButtonTransitionState>("default");
  const reset = () => setState("default");
  const run = async <T extends { saved: boolean }>(call: () => Promise<T>): Promise<T> => {
    setState("loading");

    try {
      const result = await call();

      setState(result.saved ? "success" : "error");

      return result;
    } catch (error) {
      setState("error");
      throw error;
    }
  };

  return { state, reset, run };
};
